import { useEffect, useRef } from "react";

const Starfield = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let stars = [];
    let raf;
    let t = 0;
    const mouse = { x: 0, y: 0 };

    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      const count = Math.min(300, Math.floor((canvas.width * canvas.height) / 6500));
      stars = Array.from({ length: count }, () => ({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        r: Math.random() * 1.8 + 0.4,
        phase: Math.random() * Math.PI * 2,
        speed: 0.4 + Math.random() * 0.8,
        depth: 0.3 + Math.random() * 0.7,
        warm: Math.random() < 0.18,
      }));
    };

    const draw = () => {
      t += 0.016;
      const scroll = window.scrollY * 0.06;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      for (const s of stars) {
        const twinkle = reduced ? 0.8 : 0.45 + 0.55 * Math.sin(t * s.speed + s.phase) ** 2;
        const px = s.x + mouse.x * 12 * s.depth;
        const py = (s.y - scroll * s.depth + canvas.height) % canvas.height;
        ctx.beginPath();
        ctx.arc(px, py, s.r, 0, Math.PI * 2);
        ctx.fillStyle = s.warm
          ? `rgba(252, 211, 77, ${0.95 * twinkle})`
          : `rgba(226, 232, 255, ${0.95 * twinkle})`;
        ctx.fill();
      }
      raf = requestAnimationFrame(draw);
    };

    const onMouse = (e) => {
      mouse.x = (e.clientX / window.innerWidth - 0.5) * 2;
      mouse.y = (e.clientY / window.innerHeight - 0.5) * 2;
    };

    resize();
    draw();
    window.addEventListener("resize", resize);
    window.addEventListener("mousemove", onMouse);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
      window.removeEventListener("mousemove", onMouse);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      data-testid="starfield-canvas"
      className="fixed inset-0 z-0 h-full w-full"
      aria-hidden="true"
    />
  );
};

export default Starfield;
